import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';

/********************************************************************************** */
/** É invocada pelo parâmetro [data-container-target] existente no botão para adicionar a sucursal, que indica qual o html definido para colocar as novas sucursais */
/** Recebe os parâmetro que serão os nomes dos campos da sucursal */
/** Quando se clica no botão add para adicionar nova sucursal, faz a validação dos campos, ( para outras utilizações tem de ser alterada a função sucursal )   */
/** Se os campos da sucursal estiverem todos corretos cria um html (row, cols, etc ) e coloca os campos inseridos. */
/** Todo o html criado tem de ser formatado no interior da função */
/** Juntamente cria uns campos hidden para guardar os dados da sucursal, para posteriormente serem submetidos  */
/** Os cmpos hidden têm o nome dos originais dos parâmetros de entrada acrescentando '_1', ou '_2', ou '_n', consoante o número de sucursais já existentes  */
/** Se os campos estiverem incorretos indica qual */
/** Faz uso de funções exteriores de validação dos campos */
/*********************************************************************************** */


$.fn.adiciona_Sucursais = function(parametros) {
    var target = $(this).data('container-target'); // Recebe o parametro que o invoca
    var max_sucursais_permitidas = $(this).data('max-sucursais');
    var sucursal_currente = 0;
    const campo = new Array();
    const campo_popover = new Array();
    var init = function(params) {
        $('.' + target).append('<input type="hidden" name="numero_sucursais" value="' + sucursal_currente + '">');
        $(params).each(function(index, elem) {
            campo[index] = $('[name="' + elem + '"]');
            campo_popover[index] = new bootstrap.Popover(campo[index]);
        })
    }(parametros);
    // Valida os campos do formulário de inserção das sucursais
    var valida_sucursal = function(params) {
        var return_val = true;
        $(params).each(function(index, elem) {
            if (elem == 'codigo_postal_novasucursal') {
                if (!is_Cp($('[name="' + elem + '"]').val())) {
                    campo_popover[index].show();
                    campo[index].trigger('focus');
                    return_val = false;
                    return false;
                } else {
                    campo_popover[index].hide();
                }
            } else if (elem == 'url_novasucursal') {
                if (!is_Url($('[name="' + elem + '"]').val()) && $('[name="' + elem + '"]').val().length > 0) {
                    campo_popover[index].show();
                    campo[index].trigger('focus');
                    return_val = false;
                    return false;
                } else {
                    campo_popover[index].hide();
                }
            } else if ($('[name="' + elem + '"]').val().length < 3) {
                campo_popover[index].show();
                campo[index].trigger('focus');
                return_val = false;
                return false;
            } else {
                campo_popover[index].hide();
            }
        })
        return return_val;
    };

    $(this).on('click', parametros, function() {
        max_sucursais_permitidas = $('.btn-add').attr('data-max-sucursais');
        sucursal_currente = $('input:hidden[name="numero_sucursais"]').val();
        if (valida_sucursal(parametros) != false) {
            $('.' + target).append('<div class="row pb-2 pt-2 border-bottom border-success">');
            $(parametros).each(function(index, elem) {
                $('.' + target).find('.row:last').append('<div class="col-sm-3 align-self-center">' + $('[name="' + elem + '"]').val());
                $('.' + target).find('.row:last').find('.col-sm-3:last').append('<input type="hidden" name="' + elem + '_' + sucursal_currente + '" value="' + $('[name="' + elem + '"]').val() + '">');
                if (index == 3) {
                    $('.' + target).find('.row:last').find('.col-sm-3:last').append('<button type="button" class="btn btn-remove position-absolute end-0 pt-0 pb-0 pr-1" data-sucursal-target = "' + sucursal_currente + '"><span class="icon-cancel-circle"></span></button>');
                    // Evento para o botão que remove as sucursais já adicionadas
                    $('[data-sucursal-target="' + sucursal_currente + '"]').on('click', function(e) {
                        e.preventDefault();
                        $(this).closest('.row').remove();
                        sucursal_currente--;
                        $('.' + target).find('[name="numero_sucursais"]').val(sucursal_currente);
                        if (sucursal_currente < 1) {
                            if ($('.' + target).closest('form').find(':submit').length > 0) {
                                $('.' + target).closest('form').find(':submit').prop('disabled', true);
                            }
                        }
                        // Testa o limite de sucursais 
                        if (sucursal_currente < max_sucursais_permitidas) {; // Faz qualquer coisa
                            $('.row-container-sucursal').css('display', 'block');
                            $('.btn-add').css('display', 'block');
                        }
                    });
                }
                $('[name="' + elem + '"]').val('');
            });
            sucursal_currente++;
            $('.' + target).find('[name="numero_sucursais"]').val(sucursal_currente);
            if (sucursal_currente > 0) {
                if ($('.' + target).closest('form').find(':submit').length > 0) {
                    $('.' + target).closest('form').find(':submit').prop('disabled', false);
                }
            }
            // Testa o limite de sucursais
            if (sucursal_currente >= max_sucursais_permitidas) {
                // torna não visível os campos para a nova sucursal
                $('.row-container-sucursal').css('display', 'none');
                // torna não visível o botão para adicionar a nova sucursal
                $(this).css('display', 'none');
            }

        }
    })

}

$('.btn-add[data-container-target]').adiciona_Sucursais(["nome_novasucursal", "morada_novasucursal", "codigo_postal_novasucursal", "localidade_novasucursal", "url_novasucursal"]);